import React from 'react';
import { styled } from '@compiled/react';
import { useIntl } from 'react-intl-next';
import { N200, B400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { HtmlAnchor } from '@atlassian/help-center-common-component/analytics/html-anchor';
import messages from './messages';

export const DisclaimerFooter = () => {
    const { formatMessage } = useIntl();

    return (
        <Disclaimer>
            {formatMessage(messages.disclaimerText)}&nbsp;
            <FooterLink
                href="https://www.atlassian.com/trust/atlassian-intelligence"
                target="_blank"
                rel="noopener noreferrer"
                actionSubjectId="learnWhyLink"
            >
                {formatMessage(messages.learnWhyLink)}
            </FooterLink>
        </Disclaimer>
    );
};

const Disclaimer = styled.p({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '11px',
    lineHeight: '14px',
    color: token('color.text.subtlest', N200),
    marginTop: token('space.100', '8px'),
    flexWrap: 'wrap',
    textAlign: 'center',
});

const FooterLink = styled(HtmlAnchor)({
    color: token('color.link', B400),
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none',
    },
});
